import React, { useContext } from "react";
import { LegacyCard as Card, InlineStack, BlockStack, Button } from "@shopify/polaris";

// import context
import { PrivateContext } from "lib/context/privateContext";

const OtherCurrency = () => {
  const { cms } = useContext(PrivateContext);
  return (
    <>
      {/* <Card sectioned title={connectStripe}>
        <BlockStack>
          
            <p>{currencyBlockStripe}</p>
          
          
            <p>{payoutCurrency}</p>
          
        </BlockStack>
        <InlineStack>
          
          
            <Button variant="primary" disabled>
              {label.connect}
            </Button>
          
        </InlineStack>
      </Card>
     */}
      <Card sectioned title={cms("message.success.connectPaypalAccount")}>
        <BlockStack>
          <p>{cms("message.success.currencyBlockPaypal")}</p>
          <p>{cms("message.success.payoutCurrency")}</p>
        </BlockStack>
        <InlineStack>
          <Button variant="primary" disabled>
            {cms("section.label.connect")}
          </Button>
        </InlineStack>
      </Card>
    </>
  );
};
export default OtherCurrency;
